import { Chip } from '@mui/material';

interface TextChipProps {
    label: string;
    disabled?: boolean;
    onClick: () => void;
    clickable?: boolean;
    activeColor?: string;
    activeBackgroundColor?: string;
    disabledColor?: string;
    disabledBackgroundColor?: string;
    disabledHoverColor?: string;
    activeHoverColor?: string;
    borderColor?: string;
    borderRadius?: string | number;
}

const TextChip = ({
    label,
    disabled = false,
    onClick,
    activeColor = '#4CAF50',
    disabledColor = '#989898',
    activeBackgroundColor = '#F3FAF3',
    disabledBackgroundColor = '#EFEFEF',
    disabledHoverColor = 'gray',
    activeHoverColor = '#A5D6A7',
    borderColor,
    borderRadius = '999px'
}: TextChipProps) => {
    return (
        <Chip
            label={label}
            clickable={!disabled}
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
            sx={{
                backgroundColor: disabled ? disabledBackgroundColor : activeBackgroundColor,
                color: disabled ? disabledColor : activeColor,
                fontWeight: 700,
                lineHeight: '26px',
                justifyContent: 'center',
                fontSize: '.8rem',
                textAlign: 'center',
                pl: 0.1,
                pr: 0.1,
                border: disabled
                    ? `1px solid ${disabledColor}`
                    : `1px solid ${borderColor || activeColor}`,
                borderRadius,
                height: '26px',
                '&:hover': {
                    backgroundColor: disabled ? disabledHoverColor : activeHoverColor
                },
                '&:disabled': {
                    opacity: 1
                }
            }}
        />
    );
};

export default TextChip;
